import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import i18next from 'i18next';
import SignatureCanvas from 'react-signature-canvas';
import { useFormContext } from 'react-hook-form';
import { Box } from '@famly/mf_layout_box';
import { Text } from '@famly/mf_data-display_text';
import { Button } from '@famly/mf_input_button';
import { FormRow } from '@famly/stat_forms_form-row';
import { kinderConnectSignatureCanvasE2eId, kinderConnectSignatureClearButtonE2eId, } from './kinder-connect-capture-e2e-ids';
export const CustomSignatureCaptureRow = ({ isDisabled }) => {
    const { setValue } = useFormContext();
    const canvasRef = React.useRef(null);
    const [hasStrokes, setHasStrokes] = React.useState(false);
    const handleEnd = React.useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas || canvas.isEmpty()) {
            return;
        }
        // KinderConnect API requires PNG for Signature (photo accepts WebP, but signature is strictly PNG).
        // toDataURL() returns a "data:image/png;base64,...." URL — strip that prefix since the API wants the raw base64 body.
        const base64 = canvas.toDataURL('image/png').replace(/^data:image\/\w+;base64,/, '');
        setValue('signatureBase64', base64, { shouldValidate: true });
    }, [setValue]);
    const handleBegin = React.useCallback(() => {
        setHasStrokes(true);
    }, []);
    const handleClear = React.useCallback(() => {
        var _a;
        (_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        setHasStrokes(false);
        setValue('signatureBase64', '', { shouldValidate: true });
    }, [setValue]);
    // react-signature-canvas's canvasProps isn't typed to accept arbitrary data-* attributes,
    // so the e2e id is set directly on the underlying <canvas> node once it's mounted.
    React.useEffect(() => {
        var _a;
        (_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.getCanvas().setAttribute('data-e2e-id', kinderConnectSignatureCanvasE2eId);
    }, []);
    return (_jsx(FormRow, { children: _jsxs(Box, { width: "100%", children: [_jsx(Text, { variant: "body-small", emphasized: true, children: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.signatureCapture.label) }), _jsxs(Box, { position: "relative", borderRadius: "8px", overflow: "hidden", marginTop: 1, border: "n200", backgroundColor: "n0", children: [_jsx(SignatureCanvas, { ref: canvasRef, canvasProps: {
                                width: 560,
                                height: 160,
                                style: { display: 'block' },
                            }, onBegin: handleBegin, onEnd: handleEnd }), !hasStrokes && (_jsx(Box, { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", children: _jsx(Text, { variant: "body-small", color: "n200", children: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.signatureCapture
                                    .drawPlaceholder) }) })), hasStrokes && !isDisabled && (_jsx(Box, { position: "absolute", bottom: 1, left: 1, children: _jsx(Button, { variant: "transparent", size: "compact", icon: "close", "data-e2e-id": kinderConnectSignatureClearButtonE2eId, "aria-label": i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.signatureCapture
                                    .clearAriaLabel), onClick: handleClear }) }))] })] }) }));
};
